import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "video-wall-camera-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoWallCameraListGroup = _resolveComponent("VideoWallCameraListGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
      return (_openBlock(), _createBlock(_component_VideoWallCameraListGroup, {
        key: group.id,
        cameras: _ctx.selectCamerasByGroup(group),
        group: group
      }, null, 8, ["cameras", "group"]))
    }), 128))
  ]))
}